"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'tools.apiTool.name': 'API Request',
    'tools.apiTool.description': 'Collect data from the conversation and send API requests to configured external endpoints',
};
